$(function() {
    reset_context_preferences_layer();
    ajouter_fonction_cleanup_changement_module(reset_context_preferences_layer);
});

function reset_context_preferences_layer(){
    delete(window.sigweb2_profile_liste_id_layer_visibles);
    delete(window.sigweb2_profile_liste_id_layer_visibles_sig_default);
    delete(window.sigweb2_liste_id_layer_ortho_visibles_sig_default);
    delete(window.sigweb2_preferences_layer_initialized);
}

function ajouter_fonction_cleanup_changement_module(func) {
    // contiendra les fonctions à appeler lors d'un changement de module, afin de cleanup le module en cours par exemple.
    if (typeof(window.fonctions_cleanup_changement_module) == 'undefined') {
        window.fonctions_cleanup_changement_module = [];
    }
    window.fonctions_cleanup_changement_module.push(func);
}

function init_context_preferences_layer(){
    // #15321 / #16332 : récupération des préférences utilisateur pour les couches visibles sigweb2 et explorateur
    window.sigweb2_profile_liste_id_layer_visibles = [];
    if(document.getElementById('sigweb2_profile_liste_id_layer_visibles')){
        window.sigweb2_profile_liste_id_layer_visibles = JSON.parse(document.getElementById('sigweb2_profile_liste_id_layer_visibles').textContent);
    }
    window.sigweb2_preferences_layer_initialized = true;
}

function get_sigweb2_selected_map_layers(){
    /*
    #15321: Récupère les ids de toutes les couches sélectionnées
    */
    var selected_map_layers = $('#map-controls  .leaflet-control-layers .leaflet-control-layers-selector:checked');
    var selected_inputs = [];
    $.each(selected_map_layers, function (i, item) {
            let id_map_layer = Number($(item).attr('id-map-layer'));
            if(id_map_layer){
                selected_inputs.push(id_map_layer);
            }
    });
    return selected_inputs;
}

function get_sigweb2_hidden_layer_groups(){
    var hidden_map_layers_group = $('#map-controls .checkbox-toggle-visibility-layers-group:checked');
    var hidden_map_layers_group_inputs = [];
    $.each(hidden_map_layers_group, function (i, item) {
            let id_map_layer = Number($(item).attr('data-group-id'));
            if(id_map_layer){
                hidden_map_layers_group_inputs.push(id_map_layer);
            }
    });
    return hidden_map_layers_group_inputs;
}

function get_sigweb2_layer_base_ids(){
    /*
    Récupère les ids des couches de base actuellement disponibles
     */
    var all_layer_base = $('#map-controls .leaflet-control-layers-base .leaflet-control-layers-selector');
    var all_layer_base_ids = [];
    $.each(all_layer_base, function (i, item) {
        var id_map_layer = Number($(item).attr('id-map-layer'));
        if(id_map_layer){
            all_layer_base_ids.push(id_map_layer);
        }
    });
    return all_layer_base_ids;
}

function clear_sigweb2_selected_map_layers(){
    // déselect tout
    $('#map-controls .leaflet-control-layers .leaflet-control-layers-selector').prop('checked', false);
    $('#map-controls .checkbox-toggle-visibility-layers-group').prop('checked', false);
}

function set_sigweb2_selected_map_layers(ids_map_layer,click=false){
    /*
    coche les checkbox des layers des ids passés en paramètres
    ( au chargement de la carte, pour les préférences utilisateurs )
     */
    if(!ids_map_layer){ return;}
    // sélectionne ceux de notre liste
    $.each(ids_map_layer, function (i, item) {
        $('#map-controls .leaflet-control-layers .leaflet-control-layers-selector[id-map-layer="'+item+'"]').prop('checked', true);
        if(click){
            $('#map-controls  .leaflet-control-layers .leaflet-control-layers-selector[id-map-layer="'+item+'"]').click();
        }
    });
}


function controlesUserPreferenceMapLayerLoading() {
    $('#controlesUserPreferenceMapLayerDiv').hide();
    var load_icon = '<i class="ace-icon fa fa-spinner fa-spin" id="loading_user_preference" style="float:left;"></i>';
    $('#controlesUserPreferenceMapLayerDiv').before(load_icon);
}

function controlesUserPreferenceMapLayerLoaded() {
    $('#loading_user_preference').remove();
    $('#controlesUserPreferenceMapLayerDiv').show();
}

function get_sig_ou_explorateur_id_municipalite(sig_ou_explorateur) {
    if(sig_ou_explorateur == "sig") {
        id_municipalite = $('#id_municipalite_sig').val();
    } else {
        id_municipalite = $('#exp-ue-liste-ville').val();
    }
    return id_municipalite;
}

function controleUserPreferenceMapLayerSaveCallback(event) {
    controlesUserPreferenceMapLayerLoading();
    let ids_map_layer = get_sigweb2_selected_map_layers();
    let ids_map_hidden_layer_groups = get_sigweb2_hidden_layer_groups();
    let sig_ou_explorateur = $('#sig_ou_explorateur').val();
    let id_municipalite = get_sig_ou_explorateur_id_municipalite(sig_ou_explorateur);

    $.ajax({
        type: "POST",
        url: "/georole_web_2/user-preference-map-layer-save/",
        data: {
            'ids_map_layer': ids_map_layer,
            'ids_map_hidden_layer_groups': ids_map_hidden_layer_groups,
            'id_municipalite': id_municipalite,
            'sig_ou_explorateur': sig_ou_explorateur,
        },
        success: function(data){
            // maj de l'objet global avec les nouvelles prefs
            window.sigweb2_profile_liste_id_layer_visibles = data;
            controlesUserPreferenceMapLayerLoaded();
        }
    });
}

function controleUserPreferenceMapLayerResetCallback(event){
    controlesUserPreferenceMapLayerLoading();
    let sig_ou_explorateur = $('#sig_ou_explorateur').val();
    let id_municipalite = get_sig_ou_explorateur_id_municipalite(sig_ou_explorateur);
    $.ajax({
        type: "POST",
        url: "/georole_web_2/user-preference-map-layer-reset/",
        data: {
            'id_municipalite': id_municipalite,
            'sig_ou_explorateur': sig_ou_explorateur,
        },
        success: function(data){
            // remets les défauts
            clear_sigweb2_selected_map_layers();
            set_sigweb2_selected_map_layers(window.sigweb2_profile_liste_id_layer_visibles_sig_default);
            window.sigweb2_profile_liste_id_layer_visibles = data;
            // exception pour la "carte de base", on sélectionne la première
            $('.leaflet-control-layers-base .leaflet-control-layers-selector').first().click();
            controlesUserPreferenceMapLayerLoaded();
            infos.ajouterMessageToast({
                message: "La carte a été réinitialisée et sauvegardée avec succès.",
                messageDuree: 3000,
                icone: 'fa-check-circle-o',
                iconeCouleur: 'green'
            });
        }
    });
}

function controleBaseLayerHardcodeParMunicipaliteInitBaseLayer(idMunicipalite){

    // #14299 : val des sources layer de base hardcodes par defaut
    var sigweb2_base_layer_hardcode_par_municipalite = {
        '40043': [3]
    }
    // #14299 : on force le layer de base si prédéfinit
    if(!(idMunicipalite in sigweb2_base_layer_hardcode_par_municipalite)){return;}
    // show all base layer in sigweb2_base_layer_hardcode_par_municipalitefor idMunicipalite
    $.each(sigweb2_base_layer_hardcode_par_municipalite[idMunicipalite], function (i, item) {
        $('#map-controls  .leaflet-control-layers .leaflet-control-layers-selector[id-map-layer="'+item+'"]').click();
    });
}

function controleUserPreferenceMapLayerInitBaseLayer(){
    let user_preferences_pour_mun = sigweb2_profile_get_user_preferences_pour_current_mun();
    if(!user_preferences_pour_mun){return;}
    let layer_base_ids = get_sigweb2_layer_base_ids();
    // On parcours les layers préférences de l'utilisateurs
    for (let i = 0; i < user_preferences_pour_mun.length; i++) {
        let id_layer_vis = user_preferences_pour_mun[i];
        // Si c'est un layer de base disponible...
        if(layer_base_ids.indexOf(id_layer_vis)>-1){
            // On active ce layer.
            $('#map-controls .leaflet-control-layers-base .leaflet-control-layers-selector[id-map-layer="'+id_layer_vis+'"]').click();
            return;  // on ne devrait avoir qu'un seul layer de base en préférence.
        }
    }
}

function sigweb2_profile_get_user_preferences_pour_current_mun(){
    // Retourne les ids préférences pour la municipalité affichée si existant, sinon false
    if(!window.sigweb2_profile_liste_id_layer_visibles){return false;}
    let sig_ou_explorateur = $('#sig_ou_explorateur').val();
    let id_municipalite = get_sig_ou_explorateur_id_municipalite(sig_ou_explorateur);

    let layers_groups_masques;
    if(window.sigweb2_profile_liste_id_layer_visibles['layers_groupes_masques'] !== undefined) {
        layers_groups_masques = window.sigweb2_profile_liste_id_layer_visibles['layers_groupes_masques'][sig_ou_explorateur];
        if(layers_groups_masques !== undefined && id_municipalite in layers_groups_masques) {
            // vérifier que ce n'est pas vide également
            if(layers_groups_masques[id_municipalite].length > 0) {
                for (const groupe_id of layers_groups_masques[id_municipalite]) {
                    let checkboxLayerGroup = $(`.checkbox-toggle-visibility-layers-group[data-group-id="${groupe_id}"]`);
                    checkboxLayerGroup.prop('checked', true);
                    checkboxLayerGroup.trigger('change');
                }
            }
        }
    }

    let prefs;
    if(window.sigweb2_profile_liste_id_layer_visibles['layers_visible'] !== undefined) {
        prefs = window.sigweb2_profile_liste_id_layer_visibles['layers_visible'][sig_ou_explorateur];
    } else {
        prefs = window.sigweb2_profile_liste_id_layer_visibles[sig_ou_explorateur];
    }

    if(!(typeof prefs === 'object' && prefs !== null)){
        return false;
    }

    if(id_municipalite in prefs){
        // vérifier que ce n'est pas vide également
        if(prefs[id_municipalite].length>0){
            return prefs[id_municipalite];
        }
    }
    return false;
}

function controleUserPreferenceMapLayerInitExceptionAClick() {
    // gère l'initialisation des éléments pour lesquels on a fait une exception, à commencer par la couche des ventes
    var selected_map_layers = $('#map-controls  .leaflet-control-layers input[est-exception-a-click=1]');
    let user_preferences_pour_mun = sigweb2_profile_get_user_preferences_pour_current_mun();
    if (!user_preferences_pour_mun)return;
    $.each(selected_map_layers, function (i, item) {
        if(user_preferences_pour_mun.indexOf(Number($(item).attr('id-map-layer')))>-1){
            $(item).click();
        }
    });
}


function resetCouchesVisiblesGlobalVar(){
    window.sigweb2_profile_liste_id_layer_visibles_sig_default = [];
}
function ajouterCoucheVisibleGlobalVar(id){
    if(!window.sigweb2_profile_liste_id_layer_visibles_sig_default){
        resetCouchesVisiblesGlobalVar();
    }
    window.sigweb2_profile_liste_id_layer_visibles_sig_default.push(id);
}
function resetDefautOrthoCoucheVisibleGlobalVar(){
    window.sigweb2_liste_id_layer_ortho_visibles_sig_default = [];
}
function ajouterDefautOrthoCoucheVisibleGlobalVar(id){
    // si une mun a des orthos par défaut à la place d'une couche de base hardcodée par défaut ...
    if(!window.sigweb2_liste_id_layer_ortho_visibles_sig_default){
        resetDefautOrthoCoucheVisibleGlobalVar();
    }
    window.sigweb2_liste_id_layer_ortho_visibles_sig_default.push(id);
}


function controleUserPreferenceMapVenantNewMap(){
    var layerlistediv = $('#div-resultat-layer').find('[name="hid-filtres-layer"]');
    if (layerlistediv.length == 0) return;

    // remets les défauts
    //clear_sigweb2_selected_map_layers();
    // exception pour la "carte de base", on sélectionne la première
    //$('.leaflet-control-layers-base .leaflet-control-layers-selector').first().click()
    //On va juste changer la selection pour planififcation
    layerlistediv.each(function (){
        var inputlayer = $('#leaflet-control-accordion-layers-2 .leaflet-control-layers-selector[id-map-layer="'+$(this).val()+'"]') ;
        if(!inputlayer.is(':checked')) inputlayer.click();
    });
}
